import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async () => {
      const response = await api.get('/api/ceo-dashboard/summary');

      const data = response.data?.data || {};
      const kpis = data.kpis || {};
      const operations = data.operations || {};
      const customers = data.customers || {};
      const delegates = data.delegates || {};
      const inventory = data.inventory || {};
      const store = data.store || {};
      const trends = data.trends || [];

      const total = Number(operations.total ?? kpis.totalShipments ?? 0);
      const delivered = Number(operations.delivered ?? 0);
      const inTransit = Number(operations.outForDelivery ?? 0);
      const pending = Number(operations.pending ?? 0);
      const returned = Number(operations.returned ?? 0);

      return {
        totalShipments: Number(kpis.totalShipments ?? total),
        todayShipments: 0,
        delivered,
        inTransit,
        totalRevenue: Number(kpis.totalRevenue ?? 0),
        todayRevenue: 0,
        monthRevenue: Number(kpis.monthRevenue ?? 0),
        averageShipmentValue:
          total > 0
            ? Number(kpis.totalRevenue ?? 0) / total
            : 0,

        totalEmployees: 0,
        totalProducts: Number(inventory.products ?? 0),
        totalOrders: Number(store.orders ?? 0),

        activeShipments: inTransit,
        monthlyRevenue: Number(kpis.monthRevenue ?? 0),

        chartData: trends.map((item: any) => ({
          date: item.date,
          count: Number(item.shipments ?? 0),
          shipments: Number(item.shipments ?? 0),
          delivered: 0,
          revenue: Number(item.revenue ?? 0),
        })),

        deliveredPercentage:
          total > 0 ? Math.round((delivered / total) * 100) : 0,

        deliveryPercentage:
          total > 0 ? Math.round((inTransit / total) * 100) : 0,

        processingPercentage:
          total > 0 ? Math.round((pending / total) * 100) : 0,

        returnedPercentage:
          total > 0 ? Math.round((returned / total) * 100) : 0,

        notificationsCount: 0,

        topDelegates: (delegates.top || []).map((d: any, index: number) => ({
          name: d.name,
          deliveries: Number(d.shipments ?? 0),
          rating: 0,
          city: '',
          area: '',
          zone: '',
          avatar: d.name?.charAt(0),
          color: [
            'from-blue-500 to-cyan-500',
            'from-purple-500 to-pink-500',
            'from-orange-500 to-red-500',
            'from-emerald-500 to-teal-500',
          ][index % 4],
        })),

        recentShipments: [],
        
        customersTotal: Number(customers.total ?? 0),
        activeCustomers: Number(customers.active ?? 0),
        newCustomersThisMonth: Number(customers.newThisMonth ?? 0),
        warehouses: Number(inventory.warehouses ?? 0),
      };
    },
  });
}
